import type { StatBucket } from '../../lib/api/types'

/** Ranked list with proportional flat bars — uses the full breakdown, not just the top row. */
export function Breakdown({
  title,
  data,
  maxHeight,
}: {
  title: string
  data: StatBucket[]
  maxHeight?: string
}) {
  const sorted = [...(data ?? [])].sort((a, b) => b.value - a.value)
  const max = sorted.reduce((m, d) => Math.max(m, d.value), 0) || 1
  const total = sorted.reduce((s, d) => s + d.value, 0)

  return (
    <div className="cv-panel">
      <div className="flex items-center justify-between border-b border-line-soft px-4 py-3">
        <span className="text-[13px] font-semibold uppercase tracking-wide text-muted">{title}</span>
        <span className="text-xs tnum text-muted">{total.toLocaleString('it-IT')}</span>
      </div>
      <div className="space-y-2.5 overflow-y-auto p-4" style={maxHeight ? { maxHeight } : undefined}>
        {sorted.length === 0 && <p className="text-xs text-muted">Nessun dato nel periodo.</p>}
        {sorted.map((d) => (
          <div key={d.label}>
            <div className="mb-1 flex items-center justify-between gap-3">
              <span className="truncate text-[13px] text-lagoon">{d.label}</span>
              <span className="shrink-0 text-[13px] font-semibold tnum text-lagoon">{d.value}</span>
            </div>
            <div className="h-1.5 w-full overflow-hidden rounded-sm bg-paper">
              <div className="h-full rounded-sm bg-verdigris" style={{ width: `${(d.value / max) * 100}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
